import { useState, useEffect } from 'react'
import { testimonialsAPI } from '../services/api'
import { useNotification } from '../context/NotificationContext'
import { getErrorMessage, confirmAction } from '../utils/helpers'
import CustomSelect from '../components/common/CustomSelect'

const Testimonials = () => {
  const { showSuccess, showError } = useNotification()
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchTestimonials()
  }, [])

  const fetchTestimonials = async () => {
    try {
      const response = await testimonialsAPI.getAll()
      setItems(response.data.items || [])
    } catch (error) {
      showError(getErrorMessage(error))
    } finally {
      setLoading(false)
    }
  }

  const handleSubmit = async (e, id = null) => {
    e.preventDefault()
    const formData = new FormData(e.target)
    
    try {
      const data = {
        name: formData.get('name'),
        role: formData.get('role'),
        quote: formData.get('quote'),
        rating: formData.get('rating'),
        sort_order: formData.get('sort_order'),
      }

      if (id) {
        await testimonialsAPI.update(id, data)
        showSuccess('Review updated.')
      } else {
        await testimonialsAPI.create(data)
        showSuccess('Review added.')
      }
      
      fetchTestimonials()
      if (!id) e.target.reset()
    } catch (error) {
      showError(getErrorMessage(error))
    }
  }

  const handleDelete = async (id) => {
    if (!confirmAction('Delete this review?')) return
    
    try {
      await testimonialsAPI.delete(id)
      showSuccess('Review deleted.')
      fetchTestimonials()
    } catch (error) {
      showError(getErrorMessage(error))
    }
  }

  if (loading) return <div className="admin-page">Loading...</div>

  return (
    <div className="admin-page">
      <h2 className="admin-title">Reviews</h2>
      <p className="admin-sub">Manage customer testimonials and reviews.</p>

      <div className="row">
        <div className="col-lg-8">
          <div className="panel">
            <div className="panel-head">Existing Reviews</div>
            {items.length > 0 ? (
              items.map((item) => (
                <div key={item.id} className="item-row block">
                  <form onSubmit={(e) => handleSubmit(e, item.id)} className="item-edit">
                    <input type="number" name="sort_order" defaultValue={item.sort_order} className="form-control form-control-sm" style={{width: '70px'}} title="Order" />
                    <div style={{flex: '1 1 100%', display: 'flex', gap: '8px', flexWrap: 'wrap'}}>
                      <input type="text" name="name" defaultValue={item.name} className="form-control form-control-sm" style={{flex: '1 1 180px'}} required placeholder="Name" />
                      <input type="text" name="role" defaultValue={item.role} className="form-control form-control-sm" style={{flex: '1 1 180px'}} placeholder="Role/Title" />
                      <CustomSelect
                        name="rating"
                        defaultValue={String(item.rating ?? 5)}
                        small
                        options={[
                          { value: '5', label: '5 ★' },
                          { value: '4', label: '4 ★' },
                          { value: '3', label: '3 ★' },
                          { value: '2', label: '2 ★' },
                          { value: '1', label: '1 ★' },
                        ]}
                      />
                    </div>
                    <textarea name="quote" className="form-control form-control-sm" rows="3" defaultValue={item.quote} required placeholder="Review text" style={{flex: '1 1 100%'}}></textarea>
                    <button className="btn btn-sm btn-gold" title="Save"><i className="fa fa-check"></i></button>
                  </form>
                  <button onClick={() => handleDelete(item.id)} className="btn btn-sm btn-danger" title="Delete">
                    <i className="fa fa-trash"></i>
                  </button>
                </div>
              ))
            ) : (
              <p className="muted">No reviews yet.</p>
            )}
          </div>
        </div>

        <div className="col-lg-4">
          <div className="panel">
            <div className="panel-head">Add Review</div>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Name *</label>
                <input type="text" name="name" className="form-control" required />
              </div>
              <div className="form-group">
                <label>Role/Title</label>
                <input type="text" name="role" className="form-control" placeholder="e.g. Regular Client" />
              </div>
              <div className="form-group">
                <label>Review *</label>
                <textarea name="quote" className="form-control" rows="4" required></textarea>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Rating</label>
                    <CustomSelect
                      name="rating"
                      defaultValue="5"
                      options={[
                        { value: '5', label: '5 Stars' },
                        { value: '4', label: '4 Stars' },
                        { value: '3', label: '3 Stars' },
                        { value: '2', label: '2 Stars' },
                        { value: '1', label: '1 Star' },
                      ]}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Display order</label>
                    <input type="number" name="sort_order" className="form-control" defaultValue="10" />
                  </div>
                </div>
              </div>
              <button className="btn btn-gold btn-block">Add Review</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Testimonials
